import {
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
} from '@angular/core';
import { ClientSignSelectorHelper } from '../client-sign-selector-helper';
import {
  ClientOrderStockHelper,
  OrderStockOption,
} from './helper/client-order-stock-helper';
import { SignWithStockAmount } from '../sign-with-stock-amount';
import {
  ClientOrderStockControllerRequestService,
  StockOrderedEvent,
} from './helper/services/client-order-stock-controller-request.service';
import { SnackService } from 'src/app/services/snack.service';

@Component({
  selector: 'client-order-stock',
  templateUrl: './client-order-stock.component.html',
  styleUrls: ['./client-order-stock.component.scss'],
})
export class ClientOrderStockComponent implements OnInit, OnDestroy {
  @Input()
  sign: SignWithStockAmount;
  @Input()
  companyId: number;

  @Output()
  stockOrdered = new EventEmitter<StockOrderedEvent>();

  submitting: boolean = false;
  imageUrl: string;
  imageLoaded: boolean = false;

  constructor(
    private clientOrderStockControllerRequestService: ClientOrderStockControllerRequestService,
    private snackService: SnackService
  ) {}

  orderStockOptions: OrderStockOption[];
  otherAmountSelected: boolean;
  otherAmountEnabled: boolean = true;
  // otherAmount: number;

  orderAmount: number;
  message: string = '';

  ngOnInit(): void {
    if (this.sign.displayExampleStyle == null) {
      ClientSignSelectorHelper.setDisplayExampleStyle(this.sign);
    }
    this.orderStockOptions = ClientOrderStockHelper.prepareOrderStockOptions(
      this.sign.printProduction
    );
    this.transformImageStyle();
  }

  private transformImageStyle(): void {
    if (
      this.sign.displayExampleStyle &&
      this.sign.displayExampleStyle['background-image']
    ) {
      this.imageUrl = this.sign.displayExampleStyle['background-image'].replace(
        /url\(['"](.*)['"]\)/,
        '$1'
      );
    }
  }

  onImageLoad(): void {
    this.imageLoaded = true;
  }

  submit(): void {
    if (
      this.otherAmountSelected &&
      (!this.orderAmount || this.orderAmount <= 0)
    ) {
      this.snackService.showError('Voer een bedrag in');
      return;
    }

    const filtered = this.otherAmountSelected
      ? [this.orderAmount]
      : this.orderStockOptions.filter((o) => o.selected).map((o) => o.amount);
    if (filtered.length <= 0) {
      this.snackService.showError('Gelieve een optie te kiezen');
      return;
    }
    this.submitting = true;
    this.clientOrderStockControllerRequestService
      .orderStock(
        this.sign,
        this.companyId,
        filtered,
        this.isDirectOrder(),
        this.message
      )
      .then((event: StockOrderedEvent) => {
        this.stockOrdered.emit(event);
      })
      .finally(() => (this.submitting = false));
  }

  optionSelectedChange(amount: number, checked: boolean) {
    this.orderStockOptions.forEach((value) => {
      if (checked && value.amount !== amount) {
        value.enabled = false;
        value.selected = false;
      } else if (!checked) {
        value.enabled = true;
      } else {
        value.enabled = true;
      }
    });

    this.otherAmountEnabled = !checked;
  }

  otherOptionSelectedChange(checked: boolean) {
    //number input changes trigger a check event
    if (typeof checked === 'undefined') {
      return;
    }
    this.otherAmountSelected = checked;
    this.orderStockOptions.forEach((value) => {
      if (checked) {
        value.enabled = false;
        value.selected = false;
      } else if (!checked) {
        value.enabled = true;
      }
    });
  }

  ngOnDestroy(): void {
    this.orderStockOptions.forEach((value) => {
      value.selected = false;
      value.enabled = true;
    });
    this.orderAmount = 0;
    this.otherAmountSelected = false;
    this.otherAmountEnabled = true;
  }

  calculateTotalPriceForOption(option: OrderStockOption) {
    let total = option.pricePerUnit;
    let bulkPrice = this.findBulkPriceByAmount(total);
    if (this.sign.specialShape && this.sign.specialShape.value) {
      total += bulkPrice.capShape;
    }
    if (this.sign.reflectable && this.sign.reflectable.value) {
      total += bulkPrice.reflecting;
    }
    if (this.sign.descending) {
      total += bulkPrice.descending;
    }

    return total;
  }

  findBulkPriceByAmount(amount: number) {
    return this.sign.printProduction.bulkPrices.find(
      (value) => value.unitPrice == amount
    );
  }

  isDirectOrder(): boolean {
    return (
      this.sign.displayPrices &&
      !this.otherAmountSelected &&
      this.orderStockOptions.some((o) => o.selected && o.pricePerUnit > 0)
    );
  }
}
